import type { CarrierRateRow } from './freight-rate-card-types';

export const RATE_SEARCH_MIN_LENGTH = 2;

const normalize = (value: string): string => value.trim().toLowerCase();

export const searchCarrierRows = (rows: CarrierRateRow[], searchTerm: string): CarrierRateRow[] => {
  const term = normalize(searchTerm);
  if (term.length < RATE_SEARCH_MIN_LENGTH) return rows;
  return rows.filter((row) => normalize(row.carrierName).includes(term));
};
